import Backbone from 'backbone'
import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import template from 'scoreboard/datasets/edit/dataset-field-errors-view.hbs'
import ErrorView from 'scoreboard/components/error-view'
import appDisplay from 'scoreboard/components/app-display'
import rowTemplate from 'scoreboard/datasets/edit/dataset-field-errors-view-row.hbs'
import CovertButtonTooltips from 'scoreboard/components/covert-button-tooltips'

const DatasetFieldErrorsView = Backbone.View.extend({

	className: 'dataset-field-errors-view',

	events: {
		'click .field-error-info': 'onClickFieldErrorInfo'
	},

	/**
	 * @param {{}[]} [options.fieldErrors] The field errors to render in the table
	 * @param {String} [options.pkColumnName] The primary key's column name.
	 * @param {Boolean} [options.isSpreadsheet=false] Whether or not this dataset is a spreadsheet.
	 */
	initialize: function(options) {
		this.options = options || {}
		this.fieldErrorsById = _.keyBy(this.options.fieldErrors, 'id')
	},

	render: function() {
		this.$el.append(template(this.context()))
		this.covertButtonTooltips = new CovertButtonTooltips({ el: this.el })
		return this
	},

	context: function() {
		return _.extend({}, this._showColumnsContext(), {
			header: i18n.get('datasets.error.fieldErrors', `<q>${_.escape(this.options.fieldName)}</q>`),
			valueColumn: i18n.highlight('datasets.fields.error.table.value'),
			pkColumn: this.options.pkColumnName,
			rowNumberColumn: i18n.highlight('datasets.fields.error.table.rowNumber'),
			problemColumn: i18n.highlight('common.problem'),
			technicalDetailsColumn: i18n.highlight('common.error.technicalDetails'),
			fieldErrorRows: _.map(this.options.fieldErrors, fieldError =>
				rowTemplate(_.extend({}, this._showColumnsContext(), {
					fieldError,
					problemColumn: i18n.get(fieldError.errorCode, ...fieldError.errorArguments)
				})))
		})
	},

	_showColumnsContext: function() {
		const isSpreadsheetWithPk = this.options.isSpreadsheet && !_.isEmpty(this.options.pkColumnName)
		return {
			showRowNumberColumn: this.options.isSpreadsheet,
			showPkColumn: isSpreadsheetWithPk || !this.options.isSpreadsheet
		}
	},

	onClickFieldErrorInfo: function(e) {
		const fieldError = this._getFieldError(e)
		const message = i18n.get(fieldError.errorCode, ...fieldError.errorArguments)
		appDisplay.dialog(new ErrorView({
			message,
			stackTrace: fieldError.stackTrace,
			bypassMessageView: true
		}))
	},

	_getFieldError(e) {
		const fieldErrorId = this.$(e.target).closest('tr').data('field-error-id')
		return this.fieldErrorsById[fieldErrorId]
	},

	remove: function() {
		ErrorView.prototype.remove.apply(this, arguments)
		_.invokeMap([this.covertButtonTooltips], 'remove')
	}
})

export default DatasetFieldErrorsView
DatasetFieldErrorsView.__filename__ = 'datasets/edit/dataset-field-errors-view.js'
